import {
  createTheme,
  ThemeProvider,
  Menu,
  MenuItem,
  Stack,
  Box,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  ListItemText,
  List,
  Divider,
  Slide,
  TextField,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import BlockIcon from "@mui/icons-material/Block";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useLocalStorageContext } from "../../../Context/LocalProvider";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import styles from "./DriverHeader.module.css";
import config from "../../../Data/AuthUser";
import { DriverApis, SuspendedComment } from "../../../Data/axios";
import { useSelector } from "react-redux";
import DriverHeader from "./DriverHeader";
import AddDriver from "./AddDriver";
import * as XLSX from "xlsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Driver() {
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [selection, setSelection] = useState(null);
  const [selectionStatus, setSelectionStatus] = useState(0);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageValue, setPageValue] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [rowCountValue, setRowCountValue] = useState(0);
  const [leadFiles, setLeadFiles] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);

  // status change dialog
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusReason, setStatusReason] = useState("");
  const [selectedDriverId, setSelectedDriverId] = useState(null);
  const [newStatus, setNewStatus] = useState(null);

  // suspension reason dialog
  const [reasonOpen, setReasonOpen] = useState(false);
  const [suspensionReason, setSuspensionReason] = useState([]);

  const { data: userData } = useLocalStorageContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  // 🔹 Show alert handler
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  // 🔹 Add driver modal handlers
  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleCloseAddModal = () => setOpenAddModal(false);

  // 🔹 Suspension reason handlers
  const handleViewSuspensionReason = async (userId) => {
    try {
      const reasons = await SuspendedComment.get(userId);
      if (reasons.length > 0) {
        setSuspensionReason(reasons);
        setReasonOpen(true);
      } else {
        showAlert("No suspension reason found", "info");
      }
    } catch (error) {
      console.error("Error fetching suspended reason:", error);
      showAlert("Failed to fetch suspension reason", "error");
    }
  };
  const handleCloseReason = () => {
    setReasonOpen(false);
    setSuspensionReason([]);
  };

  // 🔹 Status change
  const handleChangeSelected = (event, ticketId) => {
    const selectedValue = event.target.value;
    setSelectedDriverId(ticketId);
    setNewStatus(selectedValue);
    setStatusDialogOpen(true);
  };

const handleConfirmStatusChange = async () => {
  console.log("🚀 handleConfirmStatusChange called");

  try {
    if (!selectedDriverId || !newStatus) {
      showAlert("No driver or status selected", "error");
      return;
    }

    // 1️⃣ First add timeline
    const timelineData = new FormData();
    timelineData.append("user_id", selectedDriverId);
    timelineData.append("status", newStatus);
    timelineData.append("reason", statusReason);

    for (let [key, value] of timelineData.entries()) {
      console.log("📤 addTimeline formData:", key, value);
    }

    const timelineResponse = await SuspendedComment.AddTimeline(timelineData);

    if (!timelineResponse.success) {
      console.warn("⚠️ Timeline save failed");
      showAlert("Timeline save failed, status not updated", "error");
      return;
    }

    // 2️⃣ Timeline saved successfully, now update status
    const statusFormData = new FormData();
    statusFormData.append("status", newStatus);
    statusFormData.append("reason", statusReason);

    const statusResponse = await DriverApis.changeStatus(selectedDriverId, statusFormData);

    console.log("🚀 changeStatus response:", statusResponse);

    // Handle string response from API
    if (statusResponse === 1602) {
      // ✅ Update local table

      getData();
      setLeadFiles((prev) =>
        prev.map((driver) =>
          driver.user_id === selectedDriverId
            ? { ...driver, Status: newStatus }
            : driver
        )
      );
      showAlert("Status updated successfully", "success");
    } else {
      console.warn("⚠️ Status update failed after timeline");
      showAlert("Status update failed after timeline", "error");
    }

  } catch (error) {
    console.error("❌ Error updating status:", error);
    showAlert("Failed to update status", "error");
  } finally {
    setStatusDialogOpen(false);
    setStatusReason("");
    setSelectedDriverId(null);
    setNewStatus(null);
  }
};

  // 🔹 Menu handlers
  const [anchorEl, setAnchorEl] = useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);
  const handleOpenMenu = (user_id) => setOpenMenuId(user_id);

  const handleViewMore = async () => {
    try {
      if (!openMenuId) {
        showAlert("No driver selected", "error");
        return;
      }
      const response = await DriverApis.getbyId(openMenuId);
      if (response && (response.user_id || response.id)) {
        return navigate(`/Users/Drivers/${openMenuId}`, {
          state: {
            data: response,
            driverId: openMenuId,
          },
        });
      } else {
        showAlert("Failed to fetch driver details", "error");
      }
    } catch (error) {
      console.error("Error fetching driver details:", error);
      showAlert("An error occurred while fetching driver details", "error");
    }
  };

  // 🔹 Get drivers list
  async function getData() {
    console.log("🚀 Fetching data with params:", { pageValue, rowsPerPage });
    const result = await DriverApis.getAll(
      pageValue,
      rowsPerPage,
      selection?.props?.value,
      searchValue,
      selectionStatus?.props?.value,
      startDate,
      endDate
    );
    console.log("📊 DriverApis.getAll response:", result);
    if (result.success) {
      const drivers = result?.data?.appusers;
      console.log("👥 Drivers list:", drivers);
      console.log("🔍 Sample driver data:", drivers?.[0]);
      console.log("✅ Verification field check:", drivers?.map(d => ({
        id: d.user_id,
        name: d.username,
        verified: d.verified,
        has_verified_field: d.hasOwnProperty('verified')
      })));
      setLeadFiles(drivers);
      setTotalPages(result?.data?.total_pages);
      setRowCountValue(result?.data?.total_records);
    } else {
      showAlert(`${result.message}`, "error");
    }
  }

  // 🔹 Export the current filtered table rows to Excel
  // Exports exactly what the table shows: leadFiles is the server-filtered page.
  // ponytail: current page only (server pagination); re-fetch with a large limit if all filtered pages are ever needed.
  const statusLabel = { 1: "Enabled", 2: "Disabled", 0: "Suspended", "1": "Enabled", "2": "Disabled", "0": "Suspended" };
  const handleExport = () => {
    if (!leadFiles?.length) {
      showAlert("No data to export", "info");
      return;
    }
    const rows = leadFiles.map((d) => ({
      "Driver ID": d.user_id,
      Name: d.username,
      Email: d.email,
      "Phone No.": d.phone,
      Location: d.address,
      Status: statusLabel[d.Status] ?? d.Status,
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), "Drivers");
    XLSX.writeFile(wb, "Driver_List.xlsx");
  };

  useEffect(() => {
    if (!isInitialLoad) {
      console.log("📡 Fetching data due to dependency change:", {
        pageValue,
        rowsPerPage,
        selection: selection?.props?.value,
        searchValue,
        selectionStatus: selectionStatus?.props?.value,
        startDate,
        endDate
      });
      getData();
    }
  }, [
    pageValue,
    rowsPerPage,
    selection?.props?.value,
    searchValue,
    selectionStatus?.props?.value,
    startDate,
    endDate,
    isInitialLoad,
  ]);

  useEffect(() => {
    const pageParam = parseInt(searchParams.get('page'));
    const rowsParam = parseInt(searchParams.get('rows'));

    let newPage = 1;
    let newRows = 10;

    if (pageParam && !isNaN(pageParam) && pageParam > 0) {
      newPage = pageParam;
    }

    if (rowsParam && !isNaN(rowsParam) && rowsParam > 0) {
      newRows = rowsParam;
    }

    console.log("📍 URL params loaded:", { pageParam, rowsParam, newPage, newRows });
    setPageValue(newPage);
    setRowsPerPage(newRows);

    // Small delay to ensure state updates complete before allowing fetch
    setTimeout(() => {
      setIsInitialLoad(false);
    }, 0);
  }, [searchParams]);

  // 🔹 Table Columns
  const columns = [
    {
      name: "user_id",
      label: "Driver ID",
      options: {
        customHeadRender: ({ index }) => (
          <th key={index} style={{ textAlign: "center", borderBottom: "1px solid #ddd" }}>
            Driver ID
          </th>
        ),
        customBodyRender: (value) => (
          <div
            key={value}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
          </div>
        ),
      },
    },
    {
      name: "username",
      label: "Name",
      options: {
        customHeadRender: ({ index }) => (
          <th key={index} style={{ textAlign: "center", borderBottom: "1px solid #ddd" }}>
            Name
          </th>
        ),
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];
          const fullRecord = leadFiles.find((item) => item.user_id === ticketId);

          if (!fullRecord) return <div>Loading...</div>;

          const imageUrl = `${config.apiImageUrl}${fullRecord.image}`;

          return (
            <div
              key={value}
              style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
              onClick={() => {
                navigate(`/Users/Drivers/${fullRecord.user_id}`, {
                  state: {
                    driverId: fullRecord.user_id,
                  },
                });
              }}
            >
              <img
                src={imageUrl}
                alt="driver"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: "10px",
                }}
              />
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontWeight: "bold" }}>{value || "Unknown"}</span>
                {fullRecord.verified == 1 && (
                  <VerifiedIcon
                    sx={{ color: "#1976d2", fontSize: 20, marginLeft: "5px" }}
                    titleAccess="Verified"
                  />
                )}
                {fullRecord.Status === "0" && (
                  <BlockIcon
                    sx={{ color: "red", fontSize: 18, marginLeft: "5px" }}
                    titleAccess="Suspended"
                  />
                )}
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        customHeadRender: ({ index }) => (
          <th key={index} style={{ textAlign: "center", borderBottom: "1px solid #ddd" }}>
            Email
          </th>
        ),
        customBodyRender: (value) => (
          <div
            key={value}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            {value || " "}
          </div>
        ),
      },
    },
    {
      name: "phone",
      label: "Phone No.",
      options: {
        customHeadRender: ({ index }) => (
          <th key={index} style={{ textAlign: "center", borderBottom: "1px solid #ddd" }}>
            Phone No.
          </th>
        ),
        customBodyRender: (value) => (
          <div
            key={value}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
          </div>
        ),
      },
    },
    {
      name: "address",
      label: "Location",
      options: {
        customHeadRender: ({ index }) => (
          <th key={index} style={{ textAlign: "center", borderBottom: "1px solid #ddd" }}>
            Location
          </th>
        ),
        customBodyRender: (value) => (
          <div
            key={value}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
          </div>
        ),
      },
    },
    {
      name: "Status",
      label: "Status",
      options: {
        customHeadRender: ({ index }) => (
          <th key={index} style={{ textAlign: "center", borderBottom: "1px solid #ddd" }}>
            Status
          </th>
        ),
        customBodyRender: (value, tableMeta) => {
          const ticketId = tableMeta.rowData[0];
          return (
            <div
              key={value}
              style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <Select
                value={value}
                onChange={(event) => handleChangeSelected(event, ticketId)}
                displayEmpty
                renderValue={(selected) => {
                  if (selected === "1" || selected === 1) return "Enabled";
                  if (selected === "2" || selected === 2) return "Disabled";
                  if (selected === "0" || selected === 0) return "Suspended";
                  return selected;
                }}
                sx={{
                  width: "130px",
                  border: "none",
                  color: "#000",
                  bgcolor: "#fff",
                  "& .MuiSelect-select": { padding: 0 },
                }}
              >
                <MenuItem value={1}>Enabled</MenuItem>
                <MenuItem value={2}>Disabled</MenuItem>
              </Select>
            </div>
          );
        },
      },
    },
    {
      name: "user_id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => (
          <th
            key={index}
            style={{
              textAlign: "center",
              paddingRight: "10px",
              borderBottom: "1px solid #ddd",
            }}
          >
            Action
          </th>
        ),
        customBodyRender: (value) => (
          <div
            key={value}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              id="basic-button"
              aria-controls={openDropMenu ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openDropMenu ? "true" : undefined}
              onClick={handleClick}
            >
              <div onClick={() => handleOpenMenu(value)}>
                <MoreHorizTwoToneIcon />
              </div>
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openDropMenu}
              onClose={handleCloseMenu}
              MenuListProps={{ "aria-labelledby": "basic-button" }}
            >
              {userPermissions?.users_driver_view !== 0 && (
                <>
                  <MenuItem onClick={handleCloseMenu}>
                    <div
                      onClick={() => handleViewMore()}
                      className="MenuItemValue"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <RemoveRedEyeIcon /> View More
                    </div>
                  </MenuItem>
                  {(() => {
                    const driver = leadFiles.find((item) => item.user_id === openMenuId);
                    return driver?.Status === "0" ? (
                      <MenuItem onClick={() => handleViewSuspensionReason(driver.user_id)}>
                        <div className="MenuItemValue" style={{ display: "flex", alignItems: "center" }}>
                          <BlockIcon sx={{ marginRight: "5px" }} /> Suspension Reason
                        </div>
                      </MenuItem>
                    ) : null;
                  })()}
                </>
              )}
            </Menu>
          </div>
        ),
      },
    },
  ];

  // 🔹 Table Options
  const rowsPerPageOptions = [5, 10, 25, 100];

  const updateUrlParams = (page, rows) => {
    const newParams = {
      page: page.toString(),
      rows: rows.toString(),
    };
    console.log("🔄 Updating URL params:", newParams);
    setSearchParams(newParams);
  };

  const options = {
    selectableRows: "none",
    elevation: 0,
    rowsPerPage,
    rowsPerPageOptions,
    page: pageValue > 0 ? pageValue - 1 : 0,
    onChangeRowsPerPage: (newRowsPerPage) => {
      if (!isInitialLoad) {
        setRowsPerPage(newRowsPerPage);
        setPageValue(1);
        updateUrlParams(1, newRowsPerPage);
      }
    },
    onChangePage: (currentPage) => {
      if (!isInitialLoad) {
        const newPage = currentPage + 1;
        setPageValue(newPage);
        updateUrlParams(newPage, rowsPerPage);
      }
    },
    customFooter: (rowCount, page, rowsPerPage, changeRowsPerPage, changePage) => {
      const totalPages = Math.ceil(rowCountValue / rowsPerPage);
      const currentPage = pageValue > 0 ? pageValue - 1 : 0;

      const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages && !isInitialLoad) {
          const actualPage = newPage + 1;
          setPageValue(actualPage);
          updateUrlParams(actualPage, rowsPerPage);
          changePage(newPage);
        }
      };

      const handleRowsPerPageChange = (newRowsPerPage) => {
        if (!isInitialLoad) {
          setRowsPerPage(newRowsPerPage);
          setPageValue(1);
          updateUrlParams(1, newRowsPerPage);
          changeRowsPerPage(newRowsPerPage);
        }
      };

      return (
        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
          <div>
            Showing {currentPage * rowsPerPage + 1} - {Math.min(rowCountValue, (currentPage + 1) * rowsPerPage)} of{" "}
            {rowCountValue} entries
          </div>
          <div>
            <label htmlFor="rowsPerPage">Rows per page: </label>
            <select
              id="rowsPerPage"
              value={rowsPerPage}
              onChange={(e) => handleRowsPerPageChange(Number(e.target.value))}
            >
              {rowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <Button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} sx={{ margin: "0 5px" }}>
              Previous
            </Button>
            <Button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage + 1 === totalPages}>
              Next
            </Button>
          </div>
        </div>
      );
    },
    page: pageValue > 0 ? pageValue - 1 : 0,
  };

  const getTheme = () =>
    createTheme({
      palette: { primary: { main: "#2196f3" } },
      typography: { fontFamily: ["Roboto", "Helvetica", "Arial"].join(",") },
      components: {
        MuiButton: { styleOverrides: { root: { textTransform: "none" } } },
      },
    });

  // Table Ends Here

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

     <Dialog open={reasonOpen} onClose={handleCloseReason} fullWidth maxWidth="sm">
  <AppBar sx={{ position: "relative" }}>
    <Toolbar>
      <Typography sx={{ flex: 1 }} variant="h6">Suspension Reason</Typography>
      <IconButton edge="end" color="inherit" onClick={handleCloseReason}>
        <CloseIcon />
      </IconButton>
    </Toolbar>
  </AppBar>
  <Box sx={{ padding: 2 }}>
    {suspensionReason.length === 0 ? (
      <Typography>No reason found</Typography>
    ) : (
      suspensionReason.map((item, index) => (
        <Box
          key={index}
          sx={{ marginBottom: 2, padding: 1, borderBottom: "1px solid #ddd" }}
        >
          <Typography variant="subtitle2" fontWeight="bold">
            {item.title}
          </Typography>
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
          <Typography variant="caption" color="text.secondary">
            {(() => {
              const d = new Date(item.time);
              if (isNaN(d)) return "N/A";
              const dd = String(d.getDate()).padStart(2, "0");
              const mm = String(d.getMonth() + 1).padStart(2, "0");
              const hh = String(d.getHours()).padStart(2, "0");
              const min = String(d.getMinutes()).padStart(2, "0");
              return `${dd}-${mm}-${d.getFullYear()} ${hh}:${min}`;
            })()}
          </Typography>
        </Box>
      ))
    )}
  </Box>
</Dialog>

    <Dialog open={statusDialogOpen} onClose={() => setStatusDialogOpen(false)} fullWidth maxWidth="sm">
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <Typography sx={{ flex: 1 }} variant="h6">
            Status Update Reason
          </Typography>
          <IconButton edge="end" color="inherit" onClick={() => setStatusDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ padding: 3 }}>
        <Typography variant="body1" gutterBottom>
          Please provide a reason for updating this driver's status.
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          placeholder="Enter reason here..."
          value={statusReason}
          onChange={(e) => setStatusReason(e.target.value)}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", marginTop: 2 }}>
          <Button onClick={() => setStatusDialogOpen(false)} sx={{ marginRight: 1 }}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleConfirmStatusChange}>
            Confirm
          </Button>
        </Box>
      </Box>
    </Dialog>


      <DriverHeader
        startDate={startDate}
        selection={selection}
        setSelection={setSelection}
        selectionStatus={selectionStatus}
        setSelectionStatus={setSelectionStatus}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <List
        style={{
          background: "none",
          padding: 5,
        }}
      >
        <React.Fragment>
          {userPermissions?.users_driver_data !== 0 && (
            <Stack
              direction="row"
              spacing={2}
              sx={{
                marginBottom: "5px",
                marginTop: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box
                onClick={handleOpenAddModal}
                sx={{
                  backgroundColor: "#1d82f5",
                  "&:hover": { backgroundColor: "orange" },
                  textAlign: "center",
                  padding: "10px",
                  marginLeft: "10px",
                  height: "40px",
                  width: "120px",
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  borderRadius: "4px",
                  fontSize: "15px",
                  fontFamily: "sans-serif",
                  cursor: "pointer",
                  marginTop: "20px",
                }}
              >
                <AddIcon />
                Add Driver
              </Box>
              <Button variant="contained" color="primary" onClick={handleExport}>
                Export
              </Button>
            </Stack>
          )}

          <AddDriver
            open={openAddModal}
            handleClose={handleCloseAddModal}
            onDriverAdded={getData}
            />
        </React.Fragment>
        <Divider />
        <ListItemText style={{ background: "white", margin: 0 }}>
          <ThemeProvider theme={getTheme()}>
            <Box className={styles.muiDataTable}>
              <MUIDataTable
                title={
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: "1.5rem",
                      color: "#333",
                    }}
                  >
                    Driver Lists
                  </span>
                }
                data={leadFiles}
                columns={columns}
                options={options}
              />
            </Box>
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default Driver;